import React from 'react';
import { useResource } from '../use-resource';
export const ResourceSubscriber = _ref => {
  let {
    children,
    resource,
    options
  } = _ref;
  const result = useResource(resource, options);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(result));
};